import { getLogger } from 'app-components/utils/core';
import type RootState from 'app-components/utils/redux-store/rootState';

import type { NavigationIntent } from './types';

const log = getLogger('navigationIntents');

type AnyNavigationIntent = NavigationIntent<Record<string, unknown>, RootState>;

const registry = new Map<string, AnyNavigationIntent>();

export const registerNavigationIntent = <TArgs extends Record<string, unknown>>(
  intent: NavigationIntent<TArgs, RootState>,
): void => {
  if (registry.has(intent.name)) {
    log.warn('Navigation intent already registered', { name: intent.name });
    return;
  }
  registry.set(intent.name, intent as AnyNavigationIntent);
};

export const getNavigationIntent = (name: string): AnyNavigationIntent | undefined => registry.get(name);

export const getNavigationIntents = (): AnyNavigationIntent[] => Array.from(registry.values());
